
































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Impressions} from '../api';
import moment from 'moment';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

@Component
export default class ImpressionComponent extends Vue {
    @Prop()
    private imp?: Impressions;

    @Prop()
    private isShare?: boolean;

    @Prop()
    private isDeleteBtn?: boolean;

    @Prop({
        type: Boolean,
        default: false,
    }) private largeFont!: boolean;

    private deleteLoading: boolean = false;

    private line10 = 'line-10';
    private line8 = 'line-8';
    private line6 = 'line-6';

    private baseURL: string = 'https://twitter.com/intent/tweet';

    private createTwitterURL() {
        if (this.imp != null) {
            const t = `[${this.imp.book_title} (${this.imp.book_author})]の感想文を書きました。%0a`;
            const url = `https://${location.host}/share/${this.imp.id}`;
            return this.baseURL + '?hashtags=三行感想文,読書&text=' + t + '&url=' + url;
        }
    }

    private removeData() {
        if (this.imp != null) {
            const imgName = `${this.imp.id}.png`;
            const res = confirm('削除しますか?');
            this.deleteLoading = true;
            if (res) {
                const ref = firebase.firestore().collection('impressions');
                ref.doc(this.imp.id).delete()
                    .then(() => {
                        return firebase.storage().ref('images').child(imgName).delete();
                    })
                    .then(() => {
                        this.$emit('reload');
                    })
                    .catch((err) => {
                        // console.log(err);
                        this.$emit('reload');
                    })
                    .finally(() => {
                        this.deleteLoading = false;
                    });
            }
        }
    }


    private reshapeString(st: string | null, len: number): string {
        if (st == null) {
            return '';
        }
        if (st.length > len) {
            return st.slice(0, len) + '....';
        } else {
            return st;
        }
    }

    private formatDate(d: string | null): string | null {
        if (d != null) {
            const date = moment(d);
            return date.format('YYYY') + '/' + date.format('MM') + '/' + date.format('DD');
        } else {
            return null;
        }
    }
}
